import { Box, Typography } from '@mui/material';
import kebabcase from 'lodash/kebabCase';
import { useParams } from 'react-router-dom';

import { YearbookParams } from '../..';
import { GradientCircle } from '../../components/GradientCircle';
import { ShareButton } from '../../components/ShareButton';
import { colors, sectionTitleGradient } from '../../constants';

interface LetterToReaderProps {
  id: string;
  paragraphs: string[];
}

const title = 'Carta ao Leitor';

export function LetterToReader({ id, paragraphs }: LetterToReaderProps) {
  const { market } = useParams<YearbookParams>();

  return (
    <Box
      component="section"
      id={id}
      display="flex"
      flexDirection="column"
      gap={4}
      mt={10}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          justifyContent: 'center',
        }}>
        <Typography
          component="h2"
          fontSize={{ xs: 28, md: 40 }}
          fontWeight={700}
          lineHeight={1.2}
          sx={{
            backgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundImage: sectionTitleGradient,
          }}>
          {title}
        </Typography>
        <ShareButton market={market} section={kebabcase(title)} size={24} />
      </Box>

      <Box
        sx={{
          p: { xs: 2, md: 3 },
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: { xs: '100%', md: '80%' },
          mx: 'auto',
          position: 'relative',
        }}>
        <GradientCircle size={300} left="0" top="0" />
        {paragraphs.map((paragraph, idx) => (
          <Typography
            key={idx}
            variant="body1"
            color={colors.white}
            lineHeight={1.8}>
            {paragraph}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}
